export default __webpack_public_path__ + "static/media/iid.b279ae52.png";